import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { authenticaitonModel } from './model/authenticaiton.model';
import { headersBase } from '../../../helper/headerBase';
//import { debug } from 'util';

@Component({
  selector: 'app-authentication-component',
  styleUrls: ['./authentication.component.css'],
  templateUrl: './authentication.component.html'
})

export class AuthenticationComponent implements OnInit {
  public authentications: AuthenticationController[];
  public email: string;
  public password: string;
  public loading: boolean;
  public passwordVisible: boolean;

  constructor(private _http: HttpClient, private router: Router) {
  }

  ngOnInit() {
    if (document.getElementById('navMenuOptions')) {
      document.getElementById('navMenuOptions').style.visibility = "hidden";
    }
    this.passwordVisible = false;
    this.logout();
  }

  public login() {
    this.loading = true;
    this._http.post<authenticaitonModel>("/" + "Authentication/postauthentication",
      {
        "UserName": this.email,
        "Password": btoa(this.password)
      })
      .subscribe(
        (response: authenticaitonModel) => {
          this.loading = false;          
          if (response && response.success) {
            localStorage.setItem('currentUser', JSON.stringify(response));
            this.router.navigate(['/']);
          }
          else {
            document.getElementById("divError").style.display = "block";
          }
        },
        (err) => {
          document.getElementById("divError2").style.display = "block";
          console.log(err);
          this.loading = false;
          //
        });
  }

  public support() {
    window.location.href = "http://servicedesk.frigelar.local/ocomon/";
  }

  public togglePasswordHide() {
    const attributeType = document.getElementById("password").getAttribute("type");
    if (attributeType === "password") {
      document.getElementById("password").setAttribute("type", "text");
      this.passwordVisible = true;
    } else {
      document.getElementById("password").setAttribute("type", "password");
      this.passwordVisible = false;
    }
  }

  public logout() {
    localStorage.setItem('currentUser', null);
  }
}

interface AuthenticationController { }
